import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { batchFinishThirdDelivery } from '../../actions/uploadExcelActions';
import { adminServerInstance } from "../../axios/instances";
import UniDialog from '../Common/UniDialog';
import { handleUploadExcel, openUploadExcel, showAlertSnackbar } from '../../reducers/uiSlice';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { getCurrentWarehouse, getUserPreference } from '../../utilities/common';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    container: {
        display: 'flex'
    },
    selectWidth: {
        width: 200
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 20 
    },
}));

function UploadExcelModal() {
    const classes = useStyles();
    const {t} = useTranslation('uploadExcel');
    const dispatch = useDispatch();

    const openModal = useSelector(openUploadExcel);

    const [selectedFile, setSelectedFile] = useState(null);
    const [job, setJob] = useState('0');
    const [loading, setLoading] = useState(false);
    const [invalidOrders, setInvalidOrders] = useState([]);
    const [updatedOrders, setUpdatedOrders] = useState([]);
    const [invalidNum, setInvalidNum] = useState(0);
    const [updatedNum, setUpdatedNum] = useState(0);
    const [res, setRes] = useState(false);
    const [resScan, setResScan] = useState(false);
    const [notFoundNum, setNotFoundNum] = useState(0);
    const [updatedScanNum, setUpdatedScanNum] = useState(0);
    const [failedNum, setFailedNum] = useState(0);
    const [warehouse, setWarehouse] = useState('');

    const handleChange = (event) => {
        setJob(event.target.value);
    };

    function uploadFile() {
        setLoading(true);
        let formData = new FormData();
        formData.append('file', selectedFile);
        setRes(false);
        if(job === '1') {
            adminServerInstance.post(
                `/business/batchfinishthirddelivery`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            )
            .then((res) => {
                setLoading(false);
                dispatch(showAlertSnackbar({message: t('success'), type: 'success'}))
                setInvalidOrders(res.data.data.invalid_orders);
                setUpdatedOrders(res.data.data.updated_orders);
                setInvalidNum(res.data.data.invalid);
                setUpdatedNum(res.data.data.updated);
                setRes(true);
            })
            .catch((err) => {
                setLoading(false);
                dispatch(showAlertSnackbar({message: t('fail'), type: 'error'}))
            })
        } else if(job === '0') {
            formData.append('action_location', warehouse);
            adminServerInstance.post(
                `/business/batchtransshipment`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            )
            .then((res) => {
                setLoading(false);
                dispatch(showAlertSnackbar({message: t('success'), type: 'success'}))
                setNotFoundNum(res.data.data.not_found.length);
                setUpdatedScanNum(res.data.data.updated.length);
                setFailedNum(res.data.data.failed.length);
                setResScan(true);
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
                dispatch(showAlertSnackbar({message: t('fail'), type: 'error'}))
            })
        }
    };

    useEffect(() => {
        if(openModal) {
            setSelectedFile(undefined);
            setInvalidOrders([]);
            setUpdatedOrders([]);
            setInvalidNum(0);
            setUpdatedNum(0);
            setRes(false);
            setResScan(false);
            setNotFoundNum(0);
            setUpdatedScanNum(0);
            setFailedNum(0);
            setWarehouse(getCurrentWarehouse()['name']);
        }
    }, [openModal])

    return (
        <Fragment>
            <UniDialog
                title={t('title_upload_excel')}
                maxWidth='md'
                disableDefaultButtons
                open={openModal}
                onClose={handleClose}
                fullWidth
            >
                <input
                    color="primary"
                    type="file"
                    id="button-file"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                    style={{display: 'none'}}
                />
                <div style={{ marginBottom: 20 }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t('choose_job')}</FormLabel>
                        <RadioGroup 
                            value={job}
                            onChange={handleChange}
                            style={{
                                display: 'flex'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <FormControlLabel value='0' control={<Radio />} label={t('transaction_from_scan')} />
                                <FormControlLabel value='1' control={<Radio />} label={t('transshipment_third_party')} />
                            </div>
                            
                        </RadioGroup>
                    </FormControl>
                </div>
                <div 
                    style={{ 
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <label htmlFor="button-file">
                        <Button
                            variant="contained"
                            className={classes.selectWidth}
                            color="primary"
                            component="span"
                        >
                            {t('select_file')}
                        </Button>
                    </label>
                    <div className="file-name">
                        {selectedFile ? selectedFile.name : null}
                    </div>
                    <div style={{ display: 'flex'}}>
                        <Button
                            color="primary"
                            variant="contained"
                            component="span"
                            disabled={!selectedFile || loading}
                            onClick={()=>uploadFile(selectedFile)}
                            className={classes.selectWidth}
                        >
                            {t('upload')}
                        </Button>
                        {
                            loading &&
                            <div className={classes.buttonStyle}>
                                <CircularProgress color='secondary'/>
                            </div>                   
                        }
                    </div>
                </div>
                <div 
                    hidden={!res}
                    style={{ marginTop: 20 }}
                >
                    {t('invalid')}{invalidNum}
                </div>
                <div 
                    hidden={!res}
                    style={{ marginTop: 20 }}
                >
                    {t('updated')}{updatedNum}
                </div>
                <div 
                    hidden={!resScan}
                    style={{ marginTop: 20 }}
                >
                    {t('not_found')}{notFoundNum}
                </div>
                <div 
                    hidden={!resScan}
                    style={{ marginTop: 20 }}
                >
                    {t('updated')}{updatedScanNum}
                </div>
                <div 
                    hidden={!resScan}
                    style={{ marginTop: 20 }}
                >
                    {t('failed')}{failedNum}
                </div>
            </UniDialog>
        </Fragment>        
    );
    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleUploadExcel(false))
    }
}

export default UploadExcelModal;